import { z } from 'zod';

const candidateDocumentCategorySchema = z
  .object({
    documentCategory: z.string().nullable().optional(),
    score: z.number(),
  })
  .passthrough();

const basePredictionSchema = z
  .object({
    formName: z.string(),
    usState: z.string(),
    version: z.string().nullable().optional(),
    documentCategory: z.string().nullable().optional(),
    documentType: z.string().nullable().optional(),
    searchRegex: z.string().nullable().optional(),
    score: z.number(),
    containment: z.number().optional(),
    pageNumber: z.number(),
    formOrVersionMatch: z
      .object({
        matchesForm: z.boolean(),
        matchesVersion: z.boolean(),
        count: z.number(),
      })
      .nullable()
      .optional(),
  })
  .passthrough();

const documentPagePredictionSchema = basePredictionSchema
  .extend({
    classificationMethod: z.string().optional(),
    alternativeCandidates: z.array(basePredictionSchema).optional(),
    candidateDocumentCategories: z
      .array(candidateDocumentCategorySchema)
      .optional(),
  })
  .passthrough();

type DocumentClassification = z.infer<typeof documentPagePredictionSchema>;
type CandidateDocumentCategory = z.infer<
  typeof candidateDocumentCategorySchema
>;

const safeParseClassificationData = (
  data: unknown
): DocumentClassification[] => {
  try {
    if (!data || !Array.isArray(data)) {
      return [];
    }

    return documentPagePredictionSchema.array().parse(data);
  } catch (error) {
    return [];
  }
};

export {
  basePredictionSchema,
  CandidateDocumentCategory,
  candidateDocumentCategorySchema,
  DocumentClassification,
  documentPagePredictionSchema,
  safeParseClassificationData,
};
